import type { IconifyJSON } from '@iconify/react';

import { addCollection } from '@iconify/react';

import allIcons from './icon-sets';

// Groups the flat `prefix:name → { body }` registry into Iconify's per-prefix
// collection shape, then ships each collection to `addCollection` so they are
// available offline without round-tripping to the Iconify CDN.
export const iconSets = Object.entries(allIcons).reduce((acc, [key, value]) => {
  const colonIdx = key.indexOf(':');
  if (colonIdx === -1) return acc;
  const prefix = key.slice(0, colonIdx);
  const iconName = key.slice(colonIdx + 1);
  const existingPrefix = acc.find((item) => item.prefix === prefix);

  if (existingPrefix) {
    existingPrefix.icons[iconName] = value;
  } else {
    acc.push({
      prefix,
      icons: { [iconName]: value },
    });
  }

  return acc;
}, [] as IconifyJSON[]);

export const allIconNames = Object.keys(allIcons) as IconifyName[];

export type IconifyName = keyof typeof allIcons;

// Guarded so the first <Iconify> render registers all collections once. Default
// to 24x24 — matches the viewBox of every entry currently in `icon-sets.ts`.
let areIconsRegistered = false;

export function registerIcons() {
  if (areIconsRegistered) return;
  iconSets.forEach((iconSet) => {
    addCollection({ ...iconSet, width: 24, height: 24 });
  });
  areIconsRegistered = true;
}
